<template>
  <b-overlay>
    <b-button 
      v-b-modal.unit-modal 
      :disabled="units.length == 0" 
      class="mt-1"
    >
      <i class="fa fa-search" /> Unit opzoeken 
    </b-button>
    <b-modal
      id="unit-modal"
      :ok-disabled="selectedRows.length == 0"
      :ok-title="okTitle"
      size="lg"
      draggable="true"
      title="Zoek units"
      cancel-title="Annuleren"
      @show="clearSelected"
      @ok="$emit('selected',selectedRows.map(u => u.Id))"
    >
      <b-input
        v-model="zoekterm"
        type="search"
        placeholder="Geef een zoekterm op"
      />
      <b-pagination
        v-if="filteredUnits.length > 0"
        v-model="currentPage"
        :total-rows="filteredUnits.length"
        :per-page="perPage"
        small
        
        responsive="sm"
        prev-text="Vorige"
        next-text="Volgende"
        limit="10"
        align="left"
      >
        <template #page="{ page, active }">
          <span v-if="active">Pagina {{ page }} van {{ Math.ceil(totalRows/perPage) }}</span>
          <span v-else>{{ page }}</span>
        </template>
      </b-pagination>
      <b-table
        ref="selectableTable"
        :fields="[{key:'Uk',label: 'Unitkenmerk'}, 'Kl','Po', 'Ad', 'On']"
        :items="filteredUnits"
        :select-mode="mode"
        :current-page="currentPage"
        :per-page="perPage"
        :tbody-tr-class="tbodyRowClass" 
        small
        hover
        bordered
        @row-clicked="rowClicked"
        @row-selected="onRowSelected"
      >
        <template #cell(Uk)="row">
          {{ row.item.Uk }}
        </template>
        <template 
          #cell(Ad)="row"
        >
          {{ row.item.Ad }} {{ row.item.Wp }}
        </template>
        <template #cell(Kl)="row">
          {{ row.item.Kl }}
        </template>
        <template #cell(On)="row">
          {{ row.item.On }}
        </template>
      </b-table>
      <b-btn 
        :disabled="selectedRows.length === 0" 
        class="float-right"
        @click="clearSelected"
      >
        Clear selection
      </b-btn>
      <b-table
        ref="selectedTable"
        :fields="[{key:'Uk',label: 'Unitkenmerk'}, 'Kl','Po', 'Ad', 'On']"
        :items="selectedRows"
        
        small
      
        bordered
        caption-top
        caption="Geselecteerde units"
      >
        <template #cell(Uk)="row">
          {{ row.item.Uk }}
        </template>
        <template 
          #cell(Ad)="row"
        >
          {{ row.item.Ad }} {{ row.item.Wp }}
        </template>
        <template #cell(Kl)="row">
          {{ row.item.Kl }}
        </template>
        <template #cell(On)="row">
          {{ row.item.On }}<b-button 
            class="pull-right" 
            variant="danger"
            size="sm"
            @click="() => rowClicked(row.item)"
          >
            deselecteren
          </b-button>
        </template>
      </b-table>
    </b-modal>
  </b-overlay>
</template>

<script>
export default {
  name: "UnitSelectie",
  props: {
    units: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: 'multi'
    }
  },
  data() {
    return {
      zoekterm: "",
      selected: [],
      currentPage: 1,
      perPage: 15,
      perPageOpties: [15,30,60,90],
    };
  },
  computed: {
    selectedRows() {
        return this.units.filter(item => item.selected)
      },
    filteredUnits: function () {
      var z = this.zoekterm.toLowerCase();
      return [...this.units.filter(
        (u) =>
          u.Ad.toLowerCase().includes(z) ||
          u.Kn.toLowerCase().includes(z) ||
          u.Uk.toLowerCase().includes(z) ||
          u.On.toLowerCase().includes(z) ||
          u.Po.toLowerCase().includes(z)
      )].concat(this.selected);
    },
    okTitle: function() {
        return `${this.selectedRows.length} ${this.selectedRows.length == 1 ? 'unit' : 'units'} toevegen`
    }
  },
  methods: {
    tbodyRowClass(item) {
        /* Style the row as needed */
        if(item.selected){
          return ["b-table-row-selected", "table-bg-dark", "cursor-pointer","table-active"]
        } else {
          return ["cursor-pointer"]
        }
      },
    clearSelected() {
        this.selectedRows.forEach((item) => {
          this.$delete(item, 'selected')
        })
      },
    rowClicked(item) {
      if(item.selected){      
        this.$set(item, 'selected', false)
      }else{
        this.$set(item, 'selected', true)
      }
    },
    onRowSelected(items) {
      console.log(items.length);
      //this.selected = items;
    },
  },
};
</script>